import React from 'react';

import styles from './Row.module.scss';

interface ColPropsI {
  children: React.ReactNode;
  className?: string;
  margin?: string;
  padding?: string;
  align?: string;
  justify?: string;
  height?: string;
  width?: string;
  gap?: string;
  backgroundColor?: string;
  borderRadius?: string;
  style?: React.CSSProperties;
}

const Row: React.FC<ColPropsI> = (props: ColPropsI) => {
  const { children, className, margin } = props;
  const style = {
    margin: margin ? margin : '0px',
    padding: props.padding ? props.padding : '0px',
    alignItems: props.align ? props.align : 'flex-start',
    justifyContent: props.justify ? props.justify : 'flex-start',
    height: props.height ? props.height : '100%',
    width: props.width ? props.width : '100%',
    backgroundColor: props.backgroundColor ? props.backgroundColor : 'transparent',
    borderRadius: props.borderRadius ? props.borderRadius : '0px',
    gap: props.gap ? props.gap : '0px',
    ...props.style
  };

  return (
    <div className={`${styles.Row} ${className}`} style={style}>
      {children}
    </div>
  );
};

export default Row;
